import React from 'react';
import { Form, Input, Button } from 'antd';
import Lecture from './lecture';

export default ({
  handleVideo,
  handleLectureChange,
  addNewLecture,
  lectures,
  sections,
  media,uploadMedia,
  uploadFile,removeFile,
  refreshVideos,refresh,
  profile,getMedia,
  removeSection,
  removeLecture,
  sectionId,
  getFieldDecorator,
  sectionIndex
}) => (
  <div className="curriculum-form">
    <Form.Item label="Section Title">
      {sections.length >= 2 ? (
        <Button
          onClick={() => removeSection(sectionIndex)}
          className="remove-section-btn"
          size="small"
          type="danger"
        >
              Remove Section
            </Button>
          ) : (
            ''
          )}

      {getFieldDecorator(`${sectionId}|title`, {
        rules: [
              { required: true, message: 'Please input your section title!' }
        ]
      })(<Input placeholder="section title" size="default" name="title" />)}
    </Form.Item>
    {lectures.map((item, index) => (
      <Lecture
            // eslint-disable-next-line react/no-array-index-key
        media={media}
        uploadMedia={uploadMedia}
        refreshVideos={refreshVideos}
        refresh={refresh}
        uploadFile={uploadFile}
        removeFile={removeFile}
        getMedia={getMedia}
        profile={profile}
        key={index}
        sectionId={sectionId}
        lectureIndex={index}
        sectionIndex={sectionIndex}
        lectureId={item.id}
        lecture={item}
        lecturesLength={lectures.length}
        getFieldDecorator={getFieldDecorator}
        handleLectureChange={handleLectureChange}
        handleVideoChange={handleVideo}
        removeLecture={removeLecture}
      />
        ))}
    
    <Form.Item>
      <div className="controls">
        <Button
          ghost
          type="primary"
          onClick={() => addNewLecture(sectionIndex)}
        >
              Add Lecture
            </Button>
      </div>
    </Form.Item>
    <Form.Item />
  </div>
)
;
